import {RiArrowUpSFill, RiArrowDownSFill} from "react-icons/ri";
import {format} from "date-fns";
import {de} from "date-fns/locale";

// Date formatting template for DD.MM.YYYY format
const dateTemplate = (value) => {
    if (!value) return "";
    try {
        const date = value instanceof Date ? value : new Date(value);
        return format(date, "dd.MM.yyyy", {locale: de});
    } catch (error) {
        return "";
    }
};

// Template for counting consultants assigned to each Firmenprojekt
const beraterCountTemplate = (task) => {
    if (!task || task.type === 'consultant') return "";

    // Use pre-calculated berater_count if available, otherwise return 0
    return (task.berater_count || 0).toString();
};

export const columns = [
    {
        id: "text",
        header: "Firma Kurz",
        width: 340, // 50% increase from 227px (previously 6 cm)
        sort: true,
    },
    {
        id: "start",
        header: "Start",
        width: 76, // 2 cm - Fixed width
        align: "center",
        sort: true,
        template: dateTemplate,
    },
    {
        id: "duration",
        header: "Tage",
        width: 57, // 1.5 cm - Fixed width, centered (mittig)
        align: "center",
        sort: true,
    },
    {
        id: "end",
        header: "Ende",
        width: 76, // 2 cm - Fixed width
        align: "center",
        sort: true,
        template: dateTemplate,
    },
    {
        id: "berater_count",
        header: "PM",
        width: 236, // 25% increase from 189px (previously 5 cm)
        align: "center",
        sort: true,
        template: beraterCountTemplate,
    }
];
